import { j as r } from "./atoms-v218.js";
import { forwardRef as d } from "react";
import { FormGroup as l, Legend as x, Fields as F, Input as G, Row as c } from "./atoms-v2136.js";
import { FormGroupContext as f } from "./atoms-v2130.js";
const t = ({ children: o, span: e = 1 }) => /* @__PURE__ */ r.jsx(G, { $span: e, children: o });
t.displayName = "FormGroup.Input";
const a = ({ children: o }) => /* @__PURE__ */ r.jsx(c, { "data-testid": "form-group-row", children: o });
a.displayName = "FormGroup.Row";
const p = d(
  ({ ariaHidden: o = !1, ariaLabel: e, children: m, className: n, id: i, label: s = void 0 }, u) => /* @__PURE__ */ r.jsx(f.Provider, { value: { isGroupedInput: !0 }, children: /* @__PURE__ */ r.jsxs(
    l,
    {
      "aria-hidden": o,
      "aria-label": e,
      className: n,
      id: i,
      ref: u,
      children: [
        s ? /* @__PURE__ */ r.jsx(x, { "data-testid": "form-group-legend", tagName: "legend", type: "body", variant: "expressive", children: s }) : null,
        /* @__PURE__ */ r.jsx(F, { children: m })
      ]
    }
  ) })
);
p.displayName = "FormGroup";
const v = Object.assign(p, { Input: t, Row: a });
export {
  v as FormGroup,
  t as Input,
  a as Row
};
